import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";
import { GenderValue } from "shared";
import { PatientSummaryData } from "fe-common/graphql";

export const useSummaryTranslations = (summary: PatientSummaryData) => {
  const ret = useTranslateByGender(
    summary.gender?.toLowerCase() === "male"
      ? GenderValue.MALE
      : summary.gender?.toLowerCase() === "female"
      ? GenderValue.FEMALE
      : null,
  );

  return ret;
};
